<template>
  <div
    v-if="selected && selected.length"
  >
    <v-tabs
      v-if="selected.length > 1"
      v-model="currentFeature"
      show-arrows
    >
      <v-tab
        v-for="(feature, i) in selected"
        :key="i"
        :class="featureLabel (feature, i) !==i ? 'text-caption' : ''"
      >
        {{ featureLabel (feature, i) }}
      </v-tab>
    </v-tabs>
    <v-window v-model="currentFeature">
      <v-window-item
        v-for="(feature, i) in selected"
        :key="`card-${i}`"
      >
        <feature-details :feature="feature" />
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FeatureDetails from './feature-details.vue'

export default {
  components: {
    FeatureDetails
  },
  data: () => ({
    currentFeature: 0
  }),
  computed: {
    ...mapState(['selected']),
    ...mapGetters(['config'])
  },
  methods: {
    next () {
      this.currentFeature = this.currentFeature + 1 === this.selected.length ? 0 : this.currentFeature + 1
    },
    prev () {
      this.currentFeature = this.currentFeature - 1 < 0 ? this.selected.length - 1 : this.currentFeature - 1
    },
    featureLabel (feature, i) {
      if (!feature.source) return i
      const idx = Number(feature.source.split('-').pop())
      const layer = this.config.layers[idx]
      if (!layer.labelField) return i
      return feature.properties[layer.labelField] || i
    }
  }
}
</script>
